<!-- diagnosis-badges.component.html -->
<div class="badge-container" *ngIf="badges.length">
  <img
    alt="image of a badge"
    *ngFor="let b of badges"
    [src]="b.src"
    [alt]="b.alt"
    [matTooltip]="b.tooltipKey | translate"
    class="badge-img me-2"
    [style.width.px]="size"
    [style.height.px]="size"
  />
</div>